import { render, staticRenderFns } from "./verifycodeCheck.vue?vue&type=template&id=1b839b8a"
import script from "./verifycodeCheck.vue?vue&type=script&lang=js"
export * from "./verifycodeCheck.vue?vue&type=script&lang=js"
import style0 from "./verifycodeCheck.vue?vue&type=style&index=0&id=1b839b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports